module.exports = __webpack_public_path__ + "static/infringement-issues-featured-2ffbd6a9c80be2bafad955b9d425d68c.png";